import React, { useEffect, useState, Fragment, useRef } from 'react';
import axios from 'axios';
import { useLocation, useParams, useNavigate, Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import '../sources/styles/stylesProductSingle.css';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CardProductoPrice } from '../components/CardProductoPrice';
import { PlantillaB2C1 } from './plantillas/PlantillaB2C1';
import Slider from "react-slick";
import * as Icon from 'react-bootstrap-icons';
import { Container, ListGroup, Form, Row, Col, Figure, InputGroup, Button, Modal, Table, Stack, Card, Alert, Spinner } from "react-bootstrap";

import ReactDOM from 'react-dom/client';

function ProductSingle() {
    let navigate = useNavigate();
    const Location = useLocation();
    const params = useParams();
    let item_pedido = '';
    let tipoCliente = params.item_pedido.split('-')
    const [tipoClientePagina, setTipoClientePagina] = useState('');
    const sliderRef = useRef(null);
    const queryTokenNuevo = async (item, tipo_cliente) => {
        const cookies = new Cookies();
        try {
            const ip = await consultarIp();
            const url = process.env.REACT_APP_SERVER + '/api/v1/token/productSingle';
            const body = { item_pedido: item, tipo_cliente: tipo_cliente, ipUsuario: ip };
            const { data } = await axios.post(url, body);
            cookies.set('accesToken', data.accessToken, { path: '/' })
        } catch (error) {
            console.log('Error en la consulta de token productSingle: ' + error.message);
        }
    }

    const consultarIp = async () => {
        let ip = ''
        try {
            const url = 'https://www.cloudflare.com/cdn-cgi/trace';
            const { data } = await axios.get(url);
            ip = data.split('\n')
            ip = ip[2].split('=')
            ip = ip[1];
        } catch (err) {
            const url2 = 'https://geolocation-db.com/json/';
            const { data } = await axios.get(url2);
            ip = data.IPv4;
        }
        return ip
    }

    if (Location.state === null) {
        if (tipoCliente[1] === 'B2B' || tipoCliente[1] === 'DETAL') {
            navigate('/inicioSesion', { state: { page: '/productSingle', item_pedido: tipoCliente[0] } });
        } else if (tipoCliente[1] === 'B2C') {
            item_pedido = tipoCliente[0]
            queryTokenNuevo(tipoCliente[0], tipoCliente[1]);
        } else {
            item_pedido = tipoCliente[0]
        }
    } else {
        item_pedido = Location.state.item_pedido
    }

    let [objItem, setObjItem] = useState({
        item: item_pedido,
        um: '',
        cantidad: 1,
        precio: '',
        descuento_original: '',
        descuento: '',
        valor_final: ''
    });

    let [discountShow, setDiscountShow] = useState({
        descuento: '0%',
        permiso: 'none'
    })

    const [usosData, setUsosData] = useState([]);
    const [descripcionUsos, setDescripcionUsos] = useState([]);
    const [anexosData, setAnexosData] = useState([]);
    const [fichaTecnicaData, setFichaTecnicaData] = useState([]);
    const [imagenesData, setImagenesData] = useState([]);
    const [itemsRecommendation, setItemsRecommendation] = useState([]);
    const [dataUnidadMedida, setDataUnidadMedida] = useState([]);
    const [dataPrecio, setDataPrecio] = useState([]);
    const [dataPrecioAntes, setDataPrecioAntes] = useState(0);
    const [dataDescuento, setDataDescuento] = useState([]);
    const [titulo, setTitulo] = useState('');
    const [validacionUnidadMedida, setValidacionUnidadMedida] = useState(false);
    const [show, setShow] = useState(false);
    const [volumenShow, setVolumenShow] = useState([]);
    const [cantidad, setCantidad] = useState(1);
    const [imagenBanner, setImagenBanner] = useState([]);
    const [stock, setStock] = useState(0);
    const [umStock, setUmStock] = useState('');
    const [itemEspecial, setItemEspecial] = useState('0');
    const [plantilla, setPlantilla] = useState(false);
    const [itemMetros, setItemMetros] = useState(false);
    const [item, setItem] = useState([]);
    const [showModalDisponibilidad, setShowModalDisponibilidad] = useState(false);
    const [disabledButton, setDisabledButton] = useState(true);
    const [slidesToShow, setSlidesToShow] = useState(2);

    const arrayCentro = {
        '001': 'Buga',
        '002': 'Palmira',
        '003': 'Tuluá'
    };

    let imagenBanner2 = process.env.REACT_APP_SERVER_IMAGE + 'estaticas/baner_principal-small2.webp';
    const formatoPesosColombianos = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
    });

    const formatoPorcentaje = (num) => {
        return Number(num / 100).toLocaleString(undefined, { style: 'percent', minimumFractionDigits: 2 });
    }

    const imagenPublicidad = process.env.REACT_APP_SERVER_IMAGE + 'estaticas/';

    const settings = {
        autoplay: true,
        speed: 500,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const settingsDescuentosVolumen = {
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const settings2 = {
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToShow: slidesToShow * 2,
        slidesToScroll: slidesToShow * 2,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: slidesToShow * 2,
                    slidesToScroll: slidesToShow * 2,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: slidesToShow * 1,
                    slidesToScroll: slidesToShow * 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: slidesToShow * 1,
                    slidesToScroll: slidesToShow * 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };


    const handleUnidadMedida = async e => {
        setValidacionUnidadMedida(true);
        try {
            const cookies = new Cookies();
            const accessToken = cookies.get('accesToken')
            const urlPrecios = process.env.REACT_APP_SERVER + '/api/v1/discounts/prices';
            const bodyPrecios = { item: item_pedido, unidad_de_medida: e.target.value }
            const { data } = await axios.post(urlPrecios, bodyPrecios, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });

            if (data.length > 0) {
                let precioFinal = parseInt(data[0].precio * (1 - parseFloat(dataDescuento) / 100));

                setObjItem({
                    ...objItem,
                    valor_final: precioFinal,
                    precio: precioFinal,
                    um: e.target.value
                })
                setDataPrecio(precioFinal);

                if (e.target.value === umStock) {
                    setItemMetros(false);
                } else {
                    if (usosData.metros !== '0.00') {
                        setItemMetros(true);
                    } else {
                        setItemMetros(false);
                    }
                }
            }

        } catch (error) {
            console.log(error)
        }
    }

    const handleCantidad = async e => {
        const cookies = new Cookies();
        const accessToken = cookies.get('accesToken')
        if (e.target.value % 1 === 0) {
            if (e.target.value === '0') {
                alert('La cantidad debe ser diferente de 0');
            } else {
                if (e.target.value < 0) {
                    alert('La cantidad debe ser mayor a 0');
                } else {
                    setCantidad(e.target.value)
                    const url = process.env.REACT_APP_SERVER + '/api/v1/discountsVolume';
                    const body = { item: item_pedido, cantidad: e.target.value, descuento: objItem.descuento, precio: objItem.precio };
                    const { data } = await axios.post(url, body, {
                        headers: {
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });

                    let precioAux = objItem.precio * (1 - data.descuentoFinal / 100)
                    setDataPrecio(Math.round(precioAux))
                    setDataDescuento(data.descuentoFinal);
                    setObjItem({
                        ...objItem,
                        cantidad: e.target.value,
                        valor_final: parseInt(objItem.precio * e.target.value * (1 - parseFloat(data.descuentoFinal) / 100)),
                    });
                }
            }
        } else {
            alert('La cantidad debe de ser un número entero')
        }
    }

    const queryAgregarCarrito = async () => {
        validationRoute();
        const cookies = new Cookies();
        const accessToken = cookies.get('accesToken');
        const user = cookies.get('user');

        if (cantidad !== '') {
            if (!validacionUnidadMedida) {
                objItem = ({
                    ...objItem,
                    um: dataUnidadMedida[0].unidad_de_medida,
                    descuento: dataDescuento,
                    precio: (dataPrecioAntes > 0 ? dataPrecioAntes : dataPrecio)
                });
            } else {
                objItem = ({
                    ...objItem,
                    descuento: dataDescuento,
                    precio: (dataPrecioAntes > 0 ? dataPrecioAntes : dataPrecio)
                });
            }
            try {
                let respuesta = true;
                if (user.lista_de_precios === "001") {
                    const urlCargue = process.env.REACT_APP_SERVER + '/api/v1/customers/consultCargue';
                    const responseCargue = await axios.post(urlCargue, { id_cliente: user.id_cliente, item: objItem.item, cantidad: cantidad });
                    let dataCargue = responseCargue.data;
                    if (dataCargue.respuesta !== '') {
                        respuesta = window.confirm(dataCargue.respuesta);
                    }
                }

                if (respuesta) {
                    const url = process.env.REACT_APP_SERVER + '/api/v1/shoppingCart/register'
                    const body = { objItem, cantidad: objItem.cantidad, lugar: 'productSingle' };
                    await axios.post(url, body, {
                        headers: {
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });

                    setShow(true)
                    setCantidad(1);
                    const urlCarrito = process.env.REACT_APP_SERVER + '/api/v1/shoppingCart/list';
                    const responseCarrito = await axios.get(urlCarrito, {
                        headers: {
                            "Authorization": `Bearer ${accessToken}`
                        }
                    });
                    const dataCarrito = responseCarrito.data[0];
                    cookies.set('carrito', (dataCarrito.length));

                    if (user.tipo_usuario === 'temporal') {
                        const root = ReactDOM.createRoot(
                            document.getElementById('numberCarTemporal')
                        );
                        const element = <span className="badge badge-dark">{cookies.get('carrito')}</span>
                        root.render(element);
                    } else {
                        const root = ReactDOM.createRoot(
                            document.getElementById('numberCar')
                        );
                        const element = <span className="badge badge-dark">{cookies.get('carrito')}</span>
                        root.render(element);
                    }
                }
            } catch (error) {
                console.log(error)
            }
        } else {
            alert("La cantidad debe ser diferente de vacio")
        }

    }

    const modal = <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Información</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Se agregó exitosamente el producto al carrito
            <div className="d-grid gap-2">
                <Button style={{ color: '#ffb31c' }} variant="dark" onClick={() => setShow(false)}>
                    Continuar Comprando
                </Button>
            </div>
        </Modal.Body>
    </Modal>

    const validationRoute = async () => {

        const cookies = new Cookies();
        const accessToken = cookies.get('accesToken');
        try {
            const url = process.env.REACT_APP_SERVER + "/requireAuth/routes";
            await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });

        } catch (error) {
            console.log('La validación presentó error')
            console.log(error);
            cookies.remove('accessToken', { path: "/" });
            cookies.remove('username', { path: "/" });
            cookies.remove('id', { path: "/" });
            window.location.href = "/inicioSesion";
        }
    }

    const abrirModalDisponibilidad = async () => {
        try {
            const url = process.env.REACT_APP_SERVER + '/api/v1/items/ItemExistencias';
            const response = await axios.post(url, { item: item_pedido });
            let data = response.data;
            setItem(data);
        } catch (error) {
            console.log('Error en la consulta de items: ' + error.message);
        }
        setShowModalDisponibilidad(true);
    }

    const cerrarModalDisponibilidad = () => {
        setShowModalDisponibilidad(false);
    }

    useEffect(() => {
        setSlidesToShow(2);
        let valorStock = 0;
        const cookies = new Cookies();
        const user = cookies.get('user');
        setDisabledButton(true);
        setCantidad(1);
        setObjItem({
            ...objItem,
            cantidad: 1
        });

        const queryUsos = async () => {
            try {
                const cookies = new Cookies();
                const accessToken = cookies.get('accesToken');
                if (accessToken === undefined) {
                    window.location.reload(true);
                }

                const bodyUnidad = { item: item_pedido }
                const urlUnidad = process.env.REACT_APP_SERVER + '/api/v1/discounts/prices/und';
                const responseUnidad = await axios.post(urlUnidad, bodyUnidad, {
                    headers: {
                        "Authorization": `Bearer ${accessToken}`
                    }
                });

                setDataUnidadMedida(responseUnidad.data);

                const url = process.env.REACT_APP_SERVER + `/api/V1/productSingle/${item_pedido}`;
                const response = await axios.get(url);
                setUsosData(response.data[0]);
                if (response.data[0].descripcion_producto !== "") {
                    setSlidesToShow(1);
                }
                setUmStock(response.data[0].um_inventario);
                const parser = new DOMParser();
                const htmlUsos = parser.parseFromString(response.data[0].descripcion_producto, 'text/html');
                const childNodesUsos = htmlUsos.body.childNodes;
                const htmlNodes = Array.from(childNodesUsos).map(node => node.outerHTML);
                if (htmlNodes[0]) {
                    setSlidesToShow(1);
                }
                setDescripcionUsos(htmlNodes);
                if (responseUnidad.data.length > 0) {
                    if (responseUnidad.data[0].unidad_de_medida === response.data[0].um_inventario) {
                        setItemMetros(false);
                    } else {
                        if (response.data[0].metros !== '0.00') {
                            setItemMetros(true);
                        } else {
                            setItemMetros(false);
                        }
                    }
                }

                setPlantilla('0');
                if (user.lista_de_precios === '014' || user.lista_de_precios === undefined) {
                    setItemEspecial(response.data[0].especial);
                    setPlantilla(response.data[0].plantillaB2C);
                    if (response.data[0].b2c === 'NO') {
                        setUsosData(undefined);
                    }
                } else if (user.lista_de_precios === '001') {
                    setPlantilla(response.data[0].plantillaB2B);
                    if (response.data[0].b2b === 'NO') {
                        setUsosData(undefined);
                    }
                } else if (user.lista_de_precios === '010') {
                    setPlantilla(response.data[0].plantillaDETAL);
                    if (response.data[0].detal === 'NO') {
                        setUsosData(undefined);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }

        const queryAnexos = async () => {
            try {
                const url = process.env.REACT_APP_SERVER + `/api/consulta/tabla_anexos/${item_pedido}`;
                const response = await axios.get(url);
                if (response.data.length > 0) {
                    setSlidesToShow(1);
                }

                setAnexosData(response.data);
            } catch (error) {
                console.log(error);
            }
        }

        const queryFichaTecnica = async () => {
            try {
                const url = process.env.REACT_APP_SERVER + `/api/consulta/tabla_ficha_tecnica/${item_pedido}`;
                const response = await axios.get(url);
                if (response.data.length > 0) {
                    setSlidesToShow(1);
                }
                setFichaTecnicaData(response.data);
            } catch (error) {
                console.log(error);
            }
        }

        const queryImagenes = async () => {
            try {
                const url = process.env.REACT_APP_SERVER + `/api/consulta/tabla_imagenes/` + item_pedido;
                const resultImagenes = await axios.get(url);
                if (resultImagenes.data.length > 0) {
                    let arrayVariantesAux = [];
                    resultImagenes.data.forEach(item => {
                        arrayVariantesAux.push({
                            variante: process.env.REACT_APP_SERVER_IMAGE + 'items/' + item_pedido + '_' + item.variante + '_550x550.webp',
                            thumbnail: process.env.REACT_APP_SERVER_IMAGE + 'items/' + item_pedido + '_' + item.variante + '_75x75.webp'
                        });
                    });
                    setImagenesData(arrayVariantesAux);
                }
            } catch (error) {
                console.log(error);
            }
        }

        const queryRecommendation = async () => {
            const cookies = new Cookies();
            const accessToken = cookies.get('accesToken');

            try {
                const url = process.env.REACT_APP_SERVER + `/api/v1/items/recommendation/${item_pedido}`;
                const response = await axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                if (response.data.values.length < 4) {
                    setSlidesToShow(response.data.values.length)
                }
                setItemsRecommendation(response.data.values);
                setTitulo(response.data.titulo);

            } catch (error) {
                console.log(`Ocurrió error en la consulta de los items recomendatos: ${error}`);
            }
        }

        const queryDisponibilidad = async () => {
            const cookies = new Cookies();
            const accessToken = cookies.get('accesToken');

            const urlAgotado = process.env.REACT_APP_SERVER + `/api/v1/productExhausted/${item_pedido}`;
            const dataAgotado = await axios.get(urlAgotado, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });

            if (dataAgotado.data.length > 0) {
                let stock = dataAgotado.data[0].stock;
                valorStock = stock;
                let um = dataAgotado.data[0].um_inventario;
                setStock(stock);
                setUmStock(um);
            }
        }

        const queryPrecio = async () => {
            try {
                setDataPrecioAntes(0);
                setDataPrecio(0);
                setDataDescuento(0);
                const cookies = new Cookies();
                const accessToken = cookies.get('accesToken');
                if (accessToken === undefined) {
                    window.location.reload(true);
                }

                let precio = 0;
                let precioFinal = 0;
                let descuentoFinal = 0;
                const urlCliente = process.env.REACT_APP_SERVER + '/api/v1/validarListaPrecio';
                const respCliente = await axios.get(urlCliente, {
                    headers: {
                        "Authorization": `Bearer ${accessToken}`
                    }
                });

                const urlPrecios = process.env.REACT_APP_SERVER + '/api/v1/discounts/prices';
                const bodyPrecios = { item: item_pedido }
                const { data } = await axios.post(urlPrecios, bodyPrecios, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                setTipoClientePagina(respCliente.data.tipo_cliente_pagina);

                if (respCliente.data.lista_de_precios === '014') {

                    precioFinal = parseInt(data[0].precio_despues);
                    descuentoFinal = parseFloat(data[0].descuento);
                    precio = parseInt(data[0].precio_antes);

                    if (precio !== precioFinal) {
                        setDataPrecioAntes(precio)
                    }

                } else {

                    if (respCliente.data.lista_de_precios !== '001' && respCliente.data.lista_de_precios !== '010' && respCliente.data.lista_de_precios !== '014') {
                        precioFinal = parseInt(data[0].precio_despues);
                        descuentoFinal = parseFloat(data[0].descuento);
                        precio = parseInt(data[0].precio_antes);

                        if (precio !== precioFinal) {
                            setDataPrecioAntes(precio)
                        }

                    } else {

                        const urlDescuetnos = process.env.REACT_APP_SERVER + '/api/v1/discounts';
                        const bodyDescuentos = { item_pedido: item_pedido }
                        const responseDescuentos = await axios.post(urlDescuetnos, bodyDescuentos, {
                            headers: {
                                'Authorization': `Bearer ${accessToken}`
                            }
                        });

                        const urlDescuentosPersonalize = process.env.REACT_APP_SERVER + '/api/v1/discountsVolumePersonalize';
                        const bodyDescuentosPersonalize = { item: item_pedido, cantidad: objItem.cantidad, descuento: responseDescuentos.data[0].descuentoFinal * 100 };
                        const responseeDescuentoPersonalize = await axios.post(urlDescuentosPersonalize, bodyDescuentosPersonalize, {
                            headers: {
                                'Authorization': `Bearer ${accessToken}`
                            }
                        });

                        const urlDescuentosVolumen = process.env.REACT_APP_SERVER + '/api/v1/discountsVolume';
                        const bodyDescuentosVolumen = { item: item_pedido, cantidad: objItem.cantidad, descuento: responseeDescuentoPersonalize.data.descuentoFinal };
                        const responseeDescuentoVolumen = await axios.post(urlDescuentosVolumen, bodyDescuentosVolumen, {
                            headers: {
                                'Authorization': `Bearer ${accessToken}`
                            }
                        });
                        precio = parseInt(data[0].precio);
                        precioFinal = parseInt(data[0].precio * (1 - parseFloat(responseeDescuentoVolumen.data.descuentoFinal) / 100))
                        descuentoFinal = parseFloat(responseeDescuentoVolumen.data.descuentoFinal).toFixed(2);

                        if (precio !== precioFinal) {
                            setDataPrecioAntes(precio)
                        }
                    }
                }

                setDataPrecio(Math.round(precioFinal));
                setDataDescuento(descuentoFinal);

                //Se pone 1 porque esta es la cantidad por defecto
                let total = precioFinal * 1
                if (total !== 0) {
                    if (valorStock !== 0) {
                        setDisabledButton(false);
                    }
                }
                const newObjItem = {
                    ...objItem,
                    cantidad: 1,
                    item: item_pedido,
                    precio: Math.round(precio),
                    descuento_original: descuentoFinal,
                    descuento: descuentoFinal,
                    valor_final: total,
                };
                setObjItem(newObjItem)
            } catch (err) {
                console.log(err);
            }
        }

        const queryDescuentoVolumenShow = async () => {
            const cookies = new Cookies();
            const accessToken = cookies.get('accesToken')
            try {
                const url = process.env.REACT_APP_SERVER + '/api/v1/discountsVolumeShow';
                const body = { item: item_pedido };
                const { data } = await axios.post(url, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                if (data.result) {
                    setVolumenShow(data.descuentos);
                } else {
                    console.log('Error en la consulta de mostrar descuentos por volumen: ' + data.mensaje);
                }
            } catch (error) {
                console.log('Error en la consulta de mostrar descuentos por volumen: ' + error.message);
            }
        }

        const queryDescuentoPersonalizeShow = async () => {
            const cookies = new Cookies();
            const accessToken = cookies.get('accesToken')

            try {
                const url = process.env.REACT_APP_SERVER + '/api/v1/discountsPersonalizeShow';
                const body = { item: item_pedido };
                const { data } = await axios.post(url, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                if (data.result) {
                    if (data.descuentos.length > 0) {
                        setDiscountShow({
                            descuento: data.descuentos[0].descuento + '%',
                            permiso: 'block'
                        })
                    } else {
                        setDiscountShow({
                            descuento: '0%',
                            permiso: 'none'
                        })
                    }
                } else {
                    setDiscountShow({
                        descuento: '0%',
                        permiso: 'none'
                    })
                }
            } catch (error) {
                console.log('Error en la consulta de mostrar descuentos por volumen: ' + error.message);
            }
        }

        const bannerIncicio = async () => {
            const cookies = new Cookies();
            const accessToken = cookies.get('accesToken');

            const urlBanner = process.env.REACT_APP_SERVER + '/api/v1/products/banner';
            const dataBanner = await axios.post(urlBanner, { pagina: 'productSingle' }, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            const banner = dataBanner.data;
            setImagenBanner(banner)
        }

        setTimeout(() => {
            bannerIncicio();
            queryPrecio();
            //queryUnidadMedida();
            queryDescuentoPersonalizeShow();
            queryDescuentoVolumenShow();
            queryDisponibilidad();
            queryRecommendation();
            queryUsos();
            queryAnexos();
            queryFichaTecnica();
            queryImagenes();
        }, 1000);
        // eslint-disable-next-line
    }, [item_pedido, Location]);

    return (
        <>
            <Header />
            <Container fluid style={{ backgroundColor: 'white' }}>
                <br></br>
                {
                    usosData ?
                        <Container className="mt-3 containerProductSingle" >
                            {
                                plantilla === false ?
                                    <>
                                        <div className="d-flex justify-content-center" style={{ height: '35vh', alignItems: 'center' }}>
                                            <Spinner animation="border" variant="warning" style={{ width: '100px', height: '100px' }} />
                                        </div>
                                    </>
                                    :
                                    plantilla === 'B2C1' ?
                                        <PlantillaB2C1 imagenesData={imagenesData}
                                            dataPrecio={dataPrecio}
                                            dataPrecioAntes={dataPrecioAntes}
                                            dataDescuento={dataDescuento}
                                            dataUnidadMedida={dataUnidadMedida}
                                            usosData={usosData}
                                            descripcionUsos={descripcionUsos}
                                            tipoClientePagina={tipoClientePagina}
                                            cantidad={cantidad}
                                            stock={stock}
                                            umStock={umStock}
                                            itemMetros={itemMetros}
                                            handleCantidad={handleCantidad}
                                            handleUnidadMedida={handleUnidadMedida}
                                            queryAgregarCarrito={queryAgregarCarrito}
                                            abrirModalDisponibilidad={abrirModalDisponibilidad}
                                            modal={modal}
                                            titulo={titulo}
                                            itemsRecommendation={itemsRecommendation}
                                            imagenBanner={imagenBanner}
                                            disabledButton={disabledButton}
                                        />
                                        :
                                        <>
                                            <Row xs={1} sm={2}>
                                                <Col>
                                                    <Stack>
                                                        <div style={{ position: 'relative' }}>
                                                            <Slider ref={sliderRef} {...settings} >
                                                                {
                                                                    imagenesData.length > 0
                                                                        ?
                                                                        imagenesData.map((fila, id) =>
                                                                            <Figure key={id} id={id} >
                                                                                <Figure.Image
                                                                                    width={500}
                                                                                    height={800}
                                                                                    alt="imagenPrudct"
                                                                                    src={fila.variante}
                                                                                />
                                                                            </Figure>
                                                                        )
                                                                        :
                                                                        <Figure >
                                                                            <Figure.Image
                                                                                width={500}
                                                                                height={800}
                                                                                alt="imagenPrudct"
                                                                                src={process.env.REACT_APP_SERVER_IMAGE + 'items/0_0_550x550.webp'}
                                                                            />
                                                                        </Figure>
                                                                }
                                                            </Slider>
                                                            {
                                                                parseFloat(dataDescuento) > 0 && <Button className='btnAdicionar' variant="default" style={{ position: 'absolute', top: 0, right: 0, backgroundColor: '#e60012', color: 'white' }}><b>{formatoPorcentaje(dataDescuento)}</b></Button>
                                                            }
                                                        </div>
                                                        <div>
                                                            {
                                                                imagenesData.length > 0
                                                                    ?
                                                                    imagenesData.map((item, i) =>
                                                                        <Figure key={i}  >
                                                                            <Figure.Image
                                                                                className="miniatura"
                                                                                width={75}
                                                                                height={75}
                                                                                alt="variant"
                                                                                onClick={() => { sliderRef.current.slickGoTo(i) }}
                                                                                src={item.thumbnail}
                                                                                style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', borderRadius: '8px' }}
                                                                                onError={(e) => e.target.src = process.env.REACT_APP_SERVER_IMAGE + 'items/0_0_75x75.webp'}
                                                                            />
                                                                        </Figure>
                                                                    )
                                                                    :
                                                                    <Figure >
                                                                        <Figure.Image
                                                                            width={75}
                                                                            height={75}
                                                                            alt="imagenPrudct"
                                                                            src={process.env.REACT_APP_SERVER_IMAGE + 'items/0_0_75x75.webp'}
                                                                        />
                                                                    </Figure>
                                                            }
                                                        </div>
                                                    </Stack>
                                                </Col>
                                                <Col style={{textAlign: 'center',display: 'flex',flexDirection: 'column',justifyContent: 'center'}}>
                                                    <h1 className="lh-1 fw-bold">{usosData.descripcion_alternativa}</h1>
                                                    <br></br>
                                                    <h6><b>Referencia: </b>{usosData.referencia} <b>Código: </b>{usosData.item} <b>Marca:</b> {usosData.marca}</h6>
                                                    <hr />
                                                    <br></br>
                                                    <div>
                                                        {
                                                            usosData.caracteristicas !== null ?
                                                                <h5><b>{usosData.caracteristicas}</b></h5>
                                                                :
                                                                ''
                                                        }
                                                    </div>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <div className="text_precio">
                                                            <h1 className="text-danger display-1 fw-bold">
                                                                {formatoPesosColombianos.format(itemMetros ? parseInt(dataPrecio / usosData.metros) : dataPrecio)}
                                                            </h1>
                                                            <small>
                                                                {itemMetros && <p>METRO CUADRADO</p>}
                                                                IVA incluido
                                                            </small>
                                                        </div>
                                                        <div className="div_precio_metros">
                                                            <p className="text_precio display-6 fw-bold">
                                                                {itemMetros ?
                                                                    formatoPesosColombianos.format(dataPrecio)
                                                                    :
                                                                    usosData?.metros > 0 &&
                                                                    formatoPesosColombianos.format(dataPrecio / usosData.metros)
                                                                }
                                                                <small className='fs-6'>{itemMetros && ' CAJA'}</small>
                                                            </p>
                                                        </div>
                                                        {dataPrecioAntes !== 0 && (
                                                            <div className="textoTachado">
                                                                <h4>
                                                                    <b>
                                                                        Antes: {formatoPesosColombianos.format(dataPrecioAntes)} {itemMetros && ' CAJA'}
                                                                    </b>
                                                                </h4>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {
                                                        ((usosData.precio_solo_pagina === tipoClientePagina) || (usosData.precio_solo_pagina === 'TODOS'))
                                                        &&
                                                        <Col xs={12} style={{ color: "green" }}>
                                                            <Icon.Globe /><strong> Precio solo página</strong>
                                                        </Col>
                                                    }
                                                    <div className='div_caracteristicas'>
                                                        <hr />
                                                        <div style={{ display: discountShow.permiso }}>
                                                            <p>
                                                                <b>Descuento Personalizado:  </b> {discountShow.descuento}
                                                            </p>
                                                            <hr />
                                                        </div>
                                                    </div>
                                                    <div className="divFlechasProductosNuevos d-block">
                                                        {volumenShow.length > 0 &&
                                                            <h2>Descuentos por Volumen</h2>
                                                        }
                                                        <Slider {...settingsDescuentosVolumen}>
                                                            {
                                                                volumenShow.map((item, i) =>
                                                                    <Table size="sm" key={i}>
                                                                        <tbody style={{ width: '100%', display: 'inline' }}>
                                                                            <tr>
                                                                                <td><small><b>Cantidad mínima:</b></small> {item.cantidad_minima}</td>
                                                                                <td><small><b>Cantidad máxima:</b></small> {item.cantidad_maxima}</td>
                                                                                <td><small><b>Descuento:</b></small> {formatoPorcentaje(item.descuento)}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </Table>
                                                                )
                                                            }
                                                        </Slider>
                                                    </div>
                                                    <br></br>
                                                    <Row>
                                                        <Col md={12} lg={5}>
                                                            {
                                                                stock === 0
                                                                    ?
                                                                    <label><b><span style={{ color: 'red' }}>VALIDAR DISPONIBILIDAD</span></b></label>
                                                                    :
                                                                    <div>
                                                                        <label><b>DISPONIBILIDAD:</b> {stock} {umStock} <Button variant="outline-secondary" size="sm" onClick={abrirModalDisponibilidad}><Icon.InfoCircleFill /> Ver Stock de Tiendas</Button></label>
                                                                    </div>
                                                            }
                                                        </Col>
                                                        <Col md={12} lg={7}>
                                                            <InputGroup className="mb-3">
                                                                <Button variant="outline-secondary" onClick={() => handleCantidad({ target: { value: Math.max(1, cantidad - 1) } })}>-</Button>
                                                                <Form.Control
                                                                    className="text-center"
                                                                    type="number"
                                                                    aria-label="Example text with button addon"
                                                                    aria-describedby="basic-addon1"
                                                                    min="1"
                                                                    value={cantidad}
                                                                    onChange={handleCantidad}
                                                                />
                                                                <Button variant="outline-secondary" onClick={() => handleCantidad({ target: { value: cantidad + 1 } })}>+</Button>
                                                                <Form.Select onChange={handleUnidadMedida} size="sm">
                                                                    {
                                                                        dataUnidadMedida.map((item, i) =>
                                                                            <Fragment key={i}>
                                                                                <option value={item.unidad_de_medida}>{item.unidad_de_medida}</option>
                                                                            </Fragment>
                                                                        )
                                                                    }
                                                                </Form.Select>
                                                                {
                                                                    itemEspecial === '0' ?
                                                                        <Button style={{ fontSize: '1.7rem' }} className='btnAdicionar' variant="outline-secondary" id="button-addon1" disabled={disabledButton} onClick={() => queryAgregarCarrito()}>
                                                                            <Icon.CartCheckFill />
                                                                        </Button>
                                                                        :
                                                                        <Button style={{ width: '100%' }} variant="outline-secondary" id="button-addon1" disabled={disabledButton} className='btnAdicionar' target={"_new"} href={`https://wa.me/${usosData.numero_whatsApp}?text=Hola, quisiera conocer más información sobre el producto ${usosData.descripcion_alternativa}, ítem ${usosData.item} con referencia ${usosData.referencia}`} >
                                                                            <Icon.Whatsapp />   Asesor
                                                                        </Button>
                                                                }
                                                                {modal}
                                                            </InputGroup>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <hr />
                                            <Row>
                                                {slidesToShow === 1 &&
                                                    <Col md={6}>
                                                        <h4 className='title'>INFORMACIÓN</h4>
                                                        <div style={{ textAlign: 'justify !important' }}>
                                                            {
                                                                descripcionUsos[0]
                                                                    ?
                                                                    (
                                                                        descripcionUsos.map((html, index) => (
                                                                            <div key={index} dangerouslySetInnerHTML={{ __html: html }} />
                                                                        ))
                                                                    )
                                                                    :
                                                                    (usosData.descripcion_producto)
                                                            }
                                                        </div>
                                                        <hr />
                                                        {
                                                            fichaTecnicaData.map((item, i) =>
                                                                <Col key={i} xs={12} className='p-4 px-5 mx-1'>
                                                                    <h6 className="mb-4 text-center">FICHA TÉCNICA</h6>
                                                                    <hr></hr>
                                                                    <Button onClick={() => window.open(process.env.REACT_APP_SERVER_IMAGE + 'pdf_ficha_tecnica/' + item.pdf_ficha_tecnica, '_blank')} variant='default' className="d-flex m-auto text-center rounded-circle">
                                                                        <Icon.Download style={{ height: '80px', width: '80px' }} className="m-auto w-full" />
                                                                    </Button>
                                                                    <hr />
                                                                </Col>
                                                            )
                                                        }
                                                        {
                                                            anexosData.map((item, i) =>
                                                                <ListGroup defaultActiveKey="#link1" key={i}>
                                                                    <h4 className='title'>ANEXOS</h4>
                                                                    <ListGroup.Item className='archivo' action onClick={() => window.open(process.env.REACT_APP_SERVER_IMAGE + 'pdf_anexos/' + item.pdf_anexos, '_blank')}>
                                                                        <Icon.FileEarmarkPdfFill />VER ANEXO
                                                                    </ListGroup.Item>
                                                                    <hr />
                                                                </ListGroup>
                                                            )
                                                        }
                                                    </Col>
                                                }
                                                <Col md={slidesToShow === 1 ? '6' : '12'}>
                                                    <h3>{titulo}</h3>
                                                    <Slider {...settings2}>
                                                        {
                                                            itemsRecommendation.map((item, i) =>
                                                                <Fragment key={i}>
                                                                    <CardProductoPrice propiedades={item} />
                                                                </Fragment>
                                                            )
                                                        }
                                                    </Slider>
                                                    <br></br>
                                                    <div className='border p-4 text-center mb-3'>
                                                        <h3 className='pb-3 display-4'><b><Icon.ShieldCheck /> GARANTÍA</b></h3>
                                                        <hr></hr>
                                                        <h5><b>Todos nuestros productos son originales</b> cuentan con garantía, además de <b>COMPRA PROTEGIDA.</b></h5>
                                                        <br></br>
                                                        <h5>Recibirás una confirmación de pedido y detalles de envío en tu correo electrónico.</h5>
                                                        <br></br>
                                                        <h5>Recuerda que realizamos envíos a nivel nacional y tenemos diferentes medios de pago</h5>
                                                        <br></br>
                                                        <div className="d-flex justify-content-center">
                                                            <Link to='/registrarUsuario' state={{ page: '/' }}>
                                                                <Button variant="outline-secondary">
                                                                    <h3><Icon.BoxArrowInRight /> Regístrate</h3>
                                                                </Button>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </>
                            }
                        </Container>
                        :
                        <Container><h3>Lo sentimos, este producto ya no está disponible</h3>
                            <Row style={{ alignItems: 'center' }}>
                                <Col sm={7}>
                                    <Row className="m-3 p-3 mb-0">
                                        <Col sm={12}>
                                            <h3>Contáctenos</h3>
                                        </Col>
                                        <Col sm={12}>
                                            <Card>
                                                <Card.Header>Sede Buga</Card.Header>
                                                <Card.Body>
                                                    <blockquote className="blockquote mb-0">
                                                        <small>
                                                            <Icon.GeoAlt />
                                                            Dirección: CALLE 7 10 50
                                                            <br></br>
                                                            <Icon.Telephone />
                                                            Teléfono: 2363000
                                                        </small>
                                                    </blockquote>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <Row className="m-3 p-3 mb-0">
                                        <Col sm={12}>
                                            <Card>
                                                <Card.Header>Sede Palmira</Card.Header>
                                                <Card.Body>
                                                    <blockquote className="blockquote mb-0">
                                                        <small>
                                                            <Icon.GeoAlt />
                                                            Dirección: CARRERA 33A 28 24
                                                            <br></br>
                                                            <Icon.Telephone />
                                                            Teléfono: 2660066
                                                        </small>
                                                    </blockquote>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <Row className="m-3 p-3 mb-0">
                                        <Col sm={12}>
                                            <Card>
                                                <Card.Header>Sede Tuluá</Card.Header>
                                                <Card.Body>
                                                    <blockquote className="blockquote mb-0">
                                                        <small>
                                                            <Icon.GeoAlt />
                                                            Dirección: CARRERA 40 33 21
                                                            <br></br>
                                                            <Icon.Telephone />
                                                            Teléfono:2339733
                                                        </small>
                                                    </blockquote>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col sm={5} className="m-auto m-3 p-3 ">
                                    <div style={{ textAlign: 'center' }}>
                                        <img src={imagenBanner2} style={{ width: "100%", height: "100%" }} alt="product" className="img-fluid" />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                }
                <Container fluid className="p-0">
                <div>
                    <img style={{ width: '100%', maxWidth: '100%' }} src={imagenPublicidad + 'medios-pago.webp'} alt="medios de pago" />
                </div>
                </Container>
            </Container>

            <Footer />
            <Modal
                show={showModalDisponibilidad}
                keyboard={false}
                onHide={cerrarModalDisponibilidad}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Información</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        item.length > 0
                            ?
                            <Container>
                                <b>Item:</b> {item[0].descripcion_item}
                                <br></br>
                                <b>Código:</b> {item[0].item}
                                <br></br>
                                <b>UM:</b> {item[0].um_inventario}
                                <br></br>
                                <Row>
                                    <Col sm={12}>
                                        <Table size="sm">
                                            <thead>
                                                <tr>
                                                    <th>Instalación</th>
                                                    <th>Disponible</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    item.map((item, i) =>
                                                        <tr key={i}>
                                                            <td>{arrayCentro[item.co]}</td>
                                                            <td className={item.disponibilidad < 0  && 'text-danger'}>{item.disponibilidad} {item.disponibilidad < 0  && '(Sobrerequerido)'}</td>
                                                        </tr>
                                                    )
                                                }
                                                <tr className="fw-bold">
                                                    <td>Total</td>
                                                    <td>
                                                    {item.reduce((total, current) => total + (Number(current.disponibilidad) || 0), 0)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </Container>
                            :
                            <Alert style={{ width: '400px' }} className="mx-auto text-center">
                                <b>Sin Resultados</b>
                            </Alert>
                    }
                </Modal.Body>
            </Modal>
        </>

    )
}

export { ProductSingle };